// The notice store (FR-033; data-model §12): one short message at a time ("Access updated", a role
// removed, …). A newer notice replaces the older. NoticeHost shows it and dismisses it after 6 s.
export type Notice = { id: number; text: string };

export function createNoticeStore() {
  let current: Notice | null = null;
  let nextId = 1;
  const listeners = new Set<() => void>();
  const emit = () => listeners.forEach((l) => l());
  return {
    post(text: string): void {
      current = { id: nextId++, text };
      emit();
    },
    dismiss(id?: number): void {
      if (current === null || (id !== undefined && current.id !== id)) return;
      current = null;
      emit();
    },
    getSnapshot: (): Notice | null => current,
    subscribe(listener: () => void): () => void {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}

export type NoticeStore = ReturnType<typeof createNoticeStore>;

/** The app's notices; the session controller posts role notices here. */
export const appNotices: NoticeStore = createNoticeStore();
